<template>
  <div :class="[$tvaMq]" :version="version.version">
    <!-- Metatags -->
    <teleport to="head"
      ><title>{{ $tm("metaContent").title }}</title>
      <meta name="description" :content="$tm('metaContent').description" />
      <!-- FACEBOOK -->
      <meta property="og:title" :content="$tm('metaContent').title" />
      <meta
        property="og:description"
        :content="$tm('metaContent').description"
      />
      <meta property="og:type" content="website" />
      <meta property="og:image" :content="$tm('metaContent').image" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <!-- TWITTER -->
      <meta name="twitter:site" :content="$tm('metaContent').title" />
      <meta name="twitter:title" :content="$tm('metaContent').title" />
      <meta
        name="twitter:description"
        :content="$tm('metaContent').description"
      />
      <meta name="twitter:image" :content="$tm('metaContent').image" />

      <link
        v-if="i18n.locale.value === 'en'"
        rel="alternate"
        hreflang="en"
        :href="`https://www.eni.com/static/en-IT/infographics/eni-for-2023/${route.params.page}/`"
      />
      <link
        v-if="i18n.locale.value === 'it'"
        rel="alternate"
        hreflang="it"
        :href="`https://www.eni.com/static/it-IT/infografiche/eni-for-2023/${route.params.page}/`"
      />
    </teleport>
    <!-- Routes -->
    <!-- <Loader v-if="!firstPageTransitionHappened" /> -->

    <!-- <router-view /> -->

    <router-view v-slot="{ Component, route }">
      <transition name="page-fade" @after-enter="pageToTop">
        <component :key="route.params.page" :is="Component" />
      </transition>
    </router-view>

    <HeaderWithNav :pageLinks="pageLinks" :currentPage="route.params.page" />

    <GeneralFooter />
  </div>
</template>

<script setup>
import version from "@/../package.json";
import { onMounted, provide, watch, computed } from "@vue/runtime-core";
import useTvaMq from "./plugins/tvaMq.js";
import {
  useRoute,
  // useRouter
} from "vue-router";
import { useI18n } from "vue-i18n";
import debounce from "lodash/debounce";

import GeneralFooter from "./components/general/GeneralFooter.vue";
import HeaderWithNav from "./components/general/HeaderWithNav.vue";
// import Loader from "./components/general/Loader.vue";

const { $tvaMq } = useTvaMq();

const route = useRoute();
// const router = useRouter();
const i18n = useI18n();

provide("$tvaMq", $tvaMq);
provide("version", version);

// const currentPage = ref(null);
// const firstPageTransitionHappened = ref(false);
// const animationDirection = ref("fade");
const pages = computed(() => i18n.tm("pages"));
const pageLinks = computed(() => Object.keys(pages.value));

// Calling this here is equivalent to calling it in
// beforeCreated / create in Options API
setLanguage();

onMounted(() => {
  setVHProperty();

  window.addEventListener("resize", debounce(setStyleProperties));
  window.addEventListener("orientationchange", setStyleProperties);
});

watch(
  () => route.params.page,
  () => {
    pageToTop();
  }
);

function pageToTop() {
  // // This happens only once and is to prevent showing the desktop navbar too early
  window.scrollTo(0, 0);
  setWidthMinusScrollbar();
}

function setLanguage() {
  const defaultLang = "it";
  let lang;

  let langFromOutside =
    process.env.VUE_APP_LANG ||
    document.querySelector("#app").getAttribute("lang");

  if (langFromOutside) {
    lang = langFromOutside;
  } else {
    lang = defaultLang;
  }

  i18n.locale.value = lang.toLowerCase();

  // Set html language attribute
  const htmlEl = document.querySelector("html");
  if (htmlEl) {
    htmlEl.setAttribute("lang", lang.toLowerCase());

    window.digitalData[0].page.pageLanguage =
      lang.toLowerCase() == "it" ? "it-IT" : "en-IT";
  }

  window.digitalData[0].page.pageUrl =
    lang.toLowerCase() == "it"
      ? "https://www.eni.com/static/it-IT/infografiche/eni-for-2023/"
      : "https://www.eni.com/static/en-IT/infographics/eni-for-2023/";
}

function setVHProperty() {
  if ($tvaMq.value === "mobile") {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--app-vh", `${vh}px`);
  }
}

function setWidthMinusScrollbar() {
  document.documentElement.style.setProperty(
    "--vw-no-scrollbar",
    document.documentElement.clientWidth + "px"
  );
}

function setStyleProperties() {
  setWidthMinusScrollbar();
  setVHProperty();
}
</script>

<style lang="scss">
#app {
  --vh: var(--app-vh, 1vh);

  @include p-m;

  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
